<script setup>
const ModalContent = defineAsyncComponent(() => import("~/components/Modals/ModalContent.vue"));

const modals = [
    'AlertModal',
    'WatchlistCreateAccountModal',
    'ProductNotifyModal',
    'ProductAddedToCart',
    'Seo',
    'PromoModal',
    'PreferencesModal',
]
</script>

<template>
    <ModalContent v-for="modal in modals" :id="modal"/>
</template>
